import { MagicLinkForm } from './MagicLinkForm';
import { OAuthButtons } from './OAuthButtons';

export function LoginOptions() {
  return (
    <div className="space-y-5">
      <MagicLinkForm />

      <div className="flex items-center gap-3">
        <div className="h-px flex-1 bg-white/10" />
        <span className="text-xs text-gray-500">or continue with</span>
        <div className="h-px flex-1 bg-white/10" />
      </div>

      <OAuthButtons />
    </div>
  );
}
